import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import React, { ComponentPropsWithRef } from 'react'
import { twMerge } from 'tailwind-merge'

export type OptionsType<T> = { v: T; k: string }[]
type Props<T extends string | number | boolean | readonly string[] | undefined>
    = {
    label: string
    options: OptionsType<T>
    // @ts-ignore TS2307
} & ComponentPropsWithRef<typeof Select>

export const BaseSelect = <
    T extends string | number | readonly string[] | undefined,
>(
    p: Props<T>
) => {
    const { className, onChange, value, label, options, disabled, ...rest } = p
    return (
        <FormControl className={className} fullWidth disabled={disabled}>
            <InputLabel id={`labelId-${label}`}>{label}</InputLabel>
            <Select
                labelId={`labelId-${label}`}
                id={`id-${label}`}
                value={value}
                label={label}
                onChange={onChange}
            >
                {options.map((o, i) => (
                    <MenuItem key={o.k} value={o.v}>
                        {o.k}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}
